import throttle from 'lodash/throttle';

export default throttle((e, bannerElem) => {
  const banner = document.querySelector(bannerElem);

  document.querySelectorAll('.parallax__elem').forEach((elem) => {
    const x = Math.round(e.clientX / 70);
    const y = Math.round(e.clientY / 70);
    const rotate = Math.round(+elem.getAttribute('data-rotate') + (x + y) / 3);
    const elemTrs = Number(elem.getAttribute('data-translate'));

    if (elem) {
      // eslint-disable-next-line no-param-reassign
      elem.style.transform = `
      translateX(${(window.innerWidth - 600 - e.clientX) / 20 - elemTrs}px)
      translateY(${(banner.offsetHeight - 300 - e.clientY) / (20 - elemTrs)}px)
      rotate(${rotate}deg)
    `;
    }
  });

  const img = document.querySelector('.parallax__img');
  if (img) {
    img.style.transform = `
    translateX(${(window.innerWidth - e.clientX) / 50}px)
    translateY(${(banner.offsetHeight - e.clientY) / 50}px)
  `;
  }

  const bg = document.querySelector('.parallax__bg');
  if (bg) {
    bg.style.transform = `
    translateX(${((window.innerWidth - 600 - e.clientX) / 100) * -1}px)
    translateY(${(banner.offsetHeight - 300 - e.clientY) / -35}px)
  `;
  }
}, 150);
